import { http } from '../axios';
import { shopPrefix } from '../../config';

export function deleteSelectionList(listId: string) {
    return http.delete(`${shopPrefix}/v1/selectionlists/:listId`, {
        pathParams: {
            listId
        }
    });
}
